// extracted by mini-css-extract-plugin
export var contentfulRtfImage = "Eo4sj";